import {
  Notification,
  NotificationContentCategory,
  NotificationMetadata,
  NotificationType,
} from '@/features/notifications/notification-types';
import { ProjectRole } from '@/features/projects/shared/types/project-role';
import { supabase } from '@/lib/supabase';
import { NotificationReadStatus } from '@/shared/types/filter/notification-filter-type';
import { formatDate } from '@/shared/utils/format';

export interface NotificationFilters {
  notificationTypes: NotificationType[] | undefined;
  notificationStatuses: NotificationReadStatus[] | undefined;
  notificationCategories: NotificationContentCategory[] | undefined;
  partnerIds: string[] | undefined;
  projectIds: string[] | undefined;
  subprojectIds: string[] | undefined;
  projectRoles: ProjectRole[] | undefined;
  fromDate: Date | undefined;
  toDate: Date | undefined;
}

export const getNotifications = async (
  orgId: number,
  filters?: NotificationFilters,
): Promise<Notification[]> => {
  const { data, error } = await supabase.rpc('get_notifications', {
    p_org_id: orgId,
    p_notification_types: filters?.notificationTypes || undefined,
    p_notification_statuses: filters?.notificationStatuses || undefined,
    p_date_from: filters?.fromDate
      ? formatDate({ date: filters.fromDate, formatType: 'iso' })
      : undefined,
    p_date_to: filters?.toDate
      ? formatDate({ date: filters.toDate, formatType: 'iso' })
      : undefined,
    p_partners_ids: filters?.partnerIds || undefined,
    p_project_roles: filters?.projectRoles || undefined,
    p_project_ids: filters?.projectIds?.map((id) => Number(id)) || undefined,
    p_content_categories: filters?.notificationCategories || undefined,
    p_subproject_ids:
      filters?.subprojectIds?.map((id) => Number(id)) || undefined,
  });

  if (error) throw error;

  return data.map((notification) => ({
    ...notification,
    metadata: notification.metadata as unknown as NotificationMetadata,
    content_category:
      notification.content_category as NotificationContentCategory,
  }));
};
